/* import __COLOCATED_TEMPLATE__ from './line-item.hbs'; */
import Component from '@glimmer/component';

interface Signature {
  Element: HTMLTableRowElement;

  Args: {
    amountInDollars: number;
    helpText: string;
    isLoading: boolean;
    title: string;
  };
}

export default class LineItem extends Component<Signature> {}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AffiliatePage::EarningsContainer::LineItem': typeof LineItem;
  }
}
